import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-adjustments-icon',
  templateUrl: 'adjustments-icon.component.html'
})
export class AdjustmentsIconComponent {
  constructor() {}
}
